type License = boolean;

interface LicensesStore {
    [licenseName: number]: License;
}
export const licensesStore: LicensesStore = {};

export const setModules = (module: number, isExists: boolean) => {
    licensesStore[module] = isExists;
};

export const isModuleExists = (module: number) => {
    // return true if the value (isExists) of the module is true
    // return false if the value (isExists) of the module is false or module dosn't exists in the store
    return !!licensesStore[module];
};
